import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2dda3ebe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-container" }
const _hoisted_2 = { class: "title-dialog" }
const _hoisted_3 = { class: "form-container mt-3" }
const _hoisted_4 = { class: "button-group flex justify-between w-full px-4" }

import {ref, reactive, watch} from 'vue';
import {ApprovedVersionService} from "@/_services/securite/approvedVersion/ApprovedVersionService";
import {IApprovedVersionFormSubmittedEvent, IPostApprovedVersion} from "@/models/ApprovedVersion/IApprovedVersion";

const requiredErrorMessage = 'Ce champ est obligatoire.';

export default /*#__PURE__*/_defineComponent({
  __name: 'AddApprovedVersionModal',
  props: {
    visible: {
        type: Boolean,
        required: true
    },
},
  emits: ["update:visible", "update:form-submitted"],
  setup(__props, { emit }) {

const props = __props;




const header = ref<string>('AJOUTER');
const isSubmitting = ref(false);
const formData = reactive<IPostApprovedVersion>({
    version: '',
    os: '',
    domain: '',
});
const mobileDevices = [
    { label: 'ANDROID', value: 'ANDROID' },
    { label: 'iOS', value: 'iOS' }
];
const domains = [
    { label: 'gifteo', value: 'gifteo' },
    { label: 'club-employes', value: 'club-employes' }
];

const validateNotEmptyText = (node) => {
    let value = node.value;
    const regex = new RegExp(/\S/);

    return regex.test(value);
}

const submitForm = async (formData: IPostApprovedVersion, formNode) => {
    try {
        isSubmitting.value = true;
        const axiosResponse = await ApprovedVersionService.createApprovedVersion(formData);
        if (axiosResponse?.response?.data?.hasError === true) {
            throw new Error(axiosResponse?.response?.data?.errors[0].message || "Une erreur est survenue. Veuillez réessayer.");
        }
        
        emit('update:form-submitted', {
            status: 'success',
            message: 'Version ajoutée avec succès',
        });
    } catch (axiosError: any) {
        emit('update:form-submitted', {
            status: 'error',
            message: axiosError,
        });
    } finally {
       isSubmitting.value = false;
    }
};

const closeDialog = (): void => {
    emit('update:visible', false);
    resetFormData();
};

const resetFormData = (): void => {
    formData.version = '';
    formData.os = '';
    formData.domain = '';
};

watch(() => props.visible, (newVal) => {
    if (!newVal) {
        resetFormData();
    }
});


return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: __props.visible,
    class: "dialog-container custom-dialog",
    modal: "",
    style: { width: '30rem' },
    closable: false
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(header.value), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_FormKit, {
          type: "form",
          id: "approvedVersionForm",
          onSubmit: submitForm,
          actions: false,
          "incomplete-message": "Désolé, tous les champs ne sont pas remplis correctement."
        }, {
          default: _withCtx(({ state: { valid } }) => [
            _createElementVNode("div", {
              class: _normalizeClass(['form-field', {'invalid-field': !formData.version}])
            }, [
              _createVNode(_component_FormKit, {
                type: "text",
                name: "version",
                label: "Version *",
                modelValue: formData.version,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.version) = $event)),
                "validation-rules": { validateNotEmptyText: validateNotEmptyText },
                validation: "required|validateNotEmptyText",
                "validation-messages": {
                            required: requiredErrorMessage,
                            validateNotEmptyText: requiredErrorMessage,
                        }
              }, null, 8, ["modelValue", "validation-rules", "validation-messages"])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(['form-field', {'invalid-field': !formData.os}])
            }, [
              _createVNode(_component_FormKit, {
                type: "dropdown",
                name: "os",
                modelValue: formData.os,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.os) = $event)),
                label: "Platforme *",
                options: mobileDevices,
                validation: "required|validateNotEmptyText",
                "validation-messages": {
                            required: requiredErrorMessage,
                            validateNotEmptyText: requiredErrorMessage,
                        }
              }, null, 8, ["modelValue", "validation-messages"])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(['form-field', {'invalid-field': !formData.domain}])
            }, [
              _createVNode(_component_FormKit, {
                type: "dropdown",
                name: "domain",
                modelValue: formData.domain,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.domain) = $event)),
                label: "Domaine *",
                options: domains,
                validation: "required|validateNotEmptyText",
                "validation-messages": {
                            required: requiredErrorMessage,
                            validateNotEmptyText: requiredErrorMessage,
                        }
              }, null, 8, ["modelValue", "validation-messages"])
            ], 2),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_Button, {
                type: "submit",
                disabled: !valid || isSubmitting.value,
                label: "Ajouter",
                style: _normalizeStyle({
                                backgroundColor: (!valid || isSubmitting.value) ? 'gray' : '#007bff',
                                border: (!valid || isSubmitting.value) ? '1px solid gray' : '1px solid #007bff'
                            }),
                class: "mr-3 rounded focus:outline-none focus:shadow-outline"
              }, null, 8, ["disabled", "style"]),
              _createVNode(_component_Button, {
                type: "button",
                label: "Retour",
                class: "p-button-danger",
                onClick: closeDialog
              })
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})